import React, { useContext } from "react";
import { OrderContext } from "../../../context/OrderContext";
import { ProductsContext } from "../../../context/ProductContext";
 
// import { Image } from "antd";

const Client = () => {
  const { order,handleDeleteOrder } = useContext(OrderContext);
  const { products } = useContext(ProductsContext);
  // const [courtomerData, setCoustomerData] = useState(null);
  // const menuItems = order.order;
  // const orderLocation = order.location;
  // console.log(orderLocation);
  // console.log(order.location  );
  console.log("product", products);


  

  // console.log("courtomerData", courtomerData);

  return (
    <div className="container">
      <div className="row">
        <div className="col">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Status</th>
                <th scope="col">ProductID</th>
                <th>OrderTime</th>
                <th scope="col">Client</th>
                <th scope="col">Address</th>
                <th scope="col">Phone</th>
                <th scope="col">Pending/Submitted</th>
              </tr>
            </thead>
            <tbody>
              {/* Check if courtomerData is not null or undefined */}

              {/* <tr >
                        <th scope="row">{1}</th>
                        <td>
                          <div className="border">
                            <Image width={200} src={ ""} />
                          </div>
                        </td>
                        <td>{menuItems.map((id,i)=>{
                           return(<div key={i}>
                            <p>Id={id.productId} Q={id.currentCount}</p>
                            </div>)
                        })}</td>
                        
                        <td>{orderLocation.name}</td>
                        <td>{orderLocation.phone}</td>
                        <td>{orderLocation.id}</td>
                        <td>{orderLocation.phone}</td>
                            <td>selected.deleted ? "Deleted" : "Active"</td>
                      </tr> */}
              {order.map((main, i) => {
                let id=main.id
                return (
                  <tr key={i} >
                    <td>{i}</td>
                    <td>{main.status}</td>
                    <td  className="border">
                      

                      <div>
                       {main.order && main.order.length > 0 ? (
                        main.order.map((product, i) => (
                             <div key={i} className="text-Center border p-1 ">
                              {products.filter(item=>item.id===product.productId).map((detail,i)=>{
                                let offer=(detail.price * product.currentCount) * (1 - detail.offerPercentage / 100);
                                let totalooferprice=detail.price*(1-detail.offerPercentage/100)
                               return (<div key={i} className="border">
                                  <p className="p-0 m-0">{detail.name}  {detail.offerPercentage? <>${totalooferprice.toFixed(1)}</>:<> ${detail.price}</> }</p>
                                  <p className="p-0 m-0"></p>
                                  <p className="p-0 m-0 text-between"><span>{product.currentCount}</span><span> {detail.offerPercentage?(<><span className="border rounded px-1">offer</span>  ${offer.toFixed(1)}</>):<>${detail.price*product.currentCount}</>}</span></p>
                                   </div>)
                              })}
                              {/* < span classNa  me="" style={{fontSize:"7px"}}> <span>{product.productId}</span></ span> */}
                            </div>
                            
                        ))
                      ) : (
                        <p>No products</p>
                      )}
                      </div>
                    </td>
                     <td>{main.Date}</td>
                    <td> {main.location.name}</td>
                    <td>{main.location.address}</td>
                    <td>{main.location.phone}</td>
                     <td><button onClick={(()=>handleDeleteOrder(id))} >Delete</button></td>
                  </tr>
                );
              })}

              <tr>
                <td colSpan="8">No customer data available</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
       <div className="row">
        <div className="col">

        </div>
       </div>
    </div>
  );
};

export default Client;
